(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('en')) return;

  const root = window.Shopify?.routes?.root || '/en/';
  const localizedUrl = (path) => `${root.replace(/\/$/, '')}${path}`;

  const translations = {
    'TASMOTA INFO:': {
      title: 'TASMOTA INFO:',
      html: `
        <style>
          .orange { color: orange; }
          .schwarz { color: black; }
          .fett { font-weight: bold; }
          .kasten { background-color: transparent; border: 1px solid lightgray; padding: 10px; display: inline-block; width: 100%; margin-bottom: 10px; }
          .kasten h4 { line-height: normal; margin: 0; }
        </style>
        <div class="kasten">
          <h4><span class="orange fett">!</span><span class="schwarz fett">IMPORTANT NOTICE BEFORE PURCHASE</span><span class="orange fett">!</span></h4>
        </div>
        <div class="kasten">
          <p><span class="fett">Tasmota is a powerful tool for your smart home system that helps make your home even smarter.</span></p>
          <p><span class="fett">If you are willing to explore the technology and learn something new, Tasmota opens up excellent possibilities, especially together with MQTT, for controlling your smart home more flexibly and efficiently.</span></p>
          <h4><p style="color:#FFA500"><span class="fett">UNLOCK ENDLESS POSSIBILITIES WITH TASMOTA &amp; MQTT</span></p></h4>
        </div>
        <div class="kasten">
          <p><span class="fett">Tasmota is cloud-free, fast and secure.</span></p>
          <p>
            Your data remains within your local network.<br>
            No external communication is required. No connection to servers in China is necessary.<br>
            More functionality with Home Assistant, ioBroker, openHAB, FHEM, Node-RED, Domoticz, SmartThings and many more.<br>
            MQTT integration.<br>
            Independent devices that can be controlled individually.<br>
            Faster response times.<br>
            Alexa integration without a skill.<br>
            The manufacturers' official apps, such as eWeLink, Gosund, Smart Life or Tuya, no longer work after Tasmota firmware has been installed.
          </p>
          <hr>
          <p><strong>Important information when selecting the “Tasmota” variant</strong></p>
          <p>By purchasing the “Tasmota” variant, you agree that we will flash the device at your request. The original manufacturer firmware will be deleted and replaced with the cloud-free, open-source Tasmota firmware.</p>
          <p>Exception: This does not apply to variants that are already pre-flashed with Tasmota or supplied with Tasmota by the manufacturer. These products are delivered directly by the manufacturer with Tasmota firmware installed.</p>
          <br>
          <strong><a href="${localizedUrl('/pages/tasmota-info')}" target="_blank" rel="noopener">Learn why a smart home works better with Tasmota firmware.</a></strong>
        </div>`,
    },
    'FAQ & HILFE:': {
      title: 'FAQ & HELP:',
      html: `
        <h3><span style="color:rgb(230,126,34);">Technical support &amp; setup: Everything in our Help Center</span></h3>
        <p style="margin:10px 0 16px 0;">
          Are you looking for help setting up or integrating devices into your smart home? Our
          <a href="${localizedUrl('/pages/faq')}" target="_blank" rel="noopener"><strong>Help Center &amp; FAQ</strong></a>
          provides a comprehensive collection covering the most important topics:
        </p>
        <ul style="margin-left:20px;margin-bottom:16px;">
          <li><a href="${localizedUrl('/pages/faq')}#TASMOTA" target="_blank" rel="noopener">Tasmota: Setup, advanced settings and useful links</a></li>
          <li><a href="${localizedUrl('/pages/faq')}#OPENDTU" target="_blank" rel="noopener">OpenDTU: Installation, display, OTA updates and troubleshooting</a></li>
          <li><a href="${localizedUrl('/pages/faq')}#HOME%20ASSISTANT%20GREEN" target="_blank" rel="noopener">Home Assistant Green &amp; SkyConnect</a></li>
          <li><a href="${localizedUrl('/pages/faq')}#SONOFF%20ZBDONGLE-E%20-%20HOME%20ASSISTANT" target="_blank" rel="noopener">Zigbee dongles, RF Bridge and multiprotocol</a></li>
          <li><a href="${localizedUrl('/pages/faq')}#ANLEITUNGEN%20&amp;%20DATENBL%C3%84TTER" target="_blank" rel="noopener">Device manuals and datasheets</a></li>
          <li><a href="${localizedUrl('/pages/faq')}#LIEFERUNG%20&amp;%20R%C3%9CCKGABE" target="_blank" rel="noopener">Shipping, returns and delivery information</a></li>
        </ul>
        <p style="text-align:center;">
          <a href="${localizedUrl('/pages/faq')}" target="_blank" rel="noopener">
            <img src="https://cdn.shopify.com/s/files/1/0512/4921/7729/t/9/assets/pf-67b0d6f3--wwwmediarathdeTasmotaFAQ.png?v" alt="Help Center &amp; FAQ" style="width:250px;height:250px;border:1px solid #ccc;border-radius:8px;box-shadow:0 2px 4px rgba(0,0,0,0.1);">
          </a>
        </p>
        <p style="text-align:center;margin-top:5px;">
          <a href="${localizedUrl('/pages/faq')}" target="_blank" rel="noopener" style="text-decoration:underline;font-weight:bold;">View the complete Help Center</a>
        </p>`,
    },
  };

  const replaceVisibleText = (element, value) => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim()) {
        node.nodeValue = node.nodeValue.replace(node.nodeValue.trim(), value);
        return;
      }
    }
  };

  const translateTabs = () => {
    document.querySelectorAll('[id^="tiny-tabs-title-"]').forEach((title) => {
      if (title.dataset.mrTranslated === 'en') return;
      const sourceTitle = title.textContent.trim().toUpperCase();
      const translation = translations[sourceTitle];
      if (!translation) return;

      const content = document.getElementById(title.id.replace('title', 'content'));
      if (!content) return;

      replaceVisibleText(title, translation.title);
      content.innerHTML = translation.html;
      content.setAttribute('aria-label', translation.title);
      title.dataset.mrTranslated = 'en';
    });
  };

  translateTabs();
  const observer = new MutationObserver(translateTabs);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
